import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { resdDprecApplyClassNameConfig } from './ResdDprecApplyClass.name';

/** 残存償却適用区分のENUM */
enum ResdDprecApplyClass {
  /** 行う */
  execute = '1',
  /** 行わない */
  doNotExecute = '2',
}

const resdDprecApplyClassMap = new Map([
  ['1', ResdDprecApplyClass.execute],
  ['2', ResdDprecApplyClass.doNotExecute],
]);

const rawValueToResdDprecApplyClass = rawValueToEnumWithDefault(
  resdDprecApplyClassMap,
  ResdDprecApplyClass.doNotExecute,
);

const resdDprecApplyClassToDisplay = enumToNameWithDefault(
  ResdDprecApplyClass,
  resdDprecApplyClassNameConfig,
);

const resdDprecApplyClassToDisplayWithPrefix = enumToNameWithDefault(
  ResdDprecApplyClass,
  resdDprecApplyClassNameConfig,
  true,
);

export {
  ResdDprecApplyClass,
  rawValueToResdDprecApplyClass,
  resdDprecApplyClassMap,
  resdDprecApplyClassToDisplay,
  resdDprecApplyClassToDisplayWithPrefix,
};
